import { render, staticRenderFns } from "./SafetyConfirmation.vue?vue&type=template&id=7fad5dd3"
import script from "./SafetyConfirmation.vue?vue&type=script&lang=js"
export * from "./SafetyConfirmation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports